import React from 'react';
import { Field, useFormikContext } from 'formik';
import { CheckboxUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const serverFields = [
  ['eszignoServerUrl', 'e-Szignó szerver alapcíme', 'text'],
  ['eszignoServerProfileId', 'Aláíróprofil azonosítója', 'text'],
  ['eszignoServerUsername', 'API-felhasználónév', 'text'],
  ['eszignoServerPassword', 'API-jelszó', 'password'],
  ['eszignoServerTimeoutMs', 'Időkorlát (ms)', 'number'],
];

const DigitalSigningSettingFields = ({ viewField }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="col-span-6">
        <CheckboxUI
          label="Digitális aláírás engedélyezése"
          checked={values.digitalSigningEnabled ?? false}
          onCheckedChange={(checked) => setFieldValue('digitalSigningEnabled', checked)}
          disabled={viewField}
        />
      </div>
      {serverFields.map(([name, label, type]) => (
        <div key={name} className="md:col-span-3 col-span-6">
          <Field
            name={name}
            type={type}
            as={InputUI}
            value={values[name] ?? ''}
            fullWidth
            variant="standard"
            label={<FormLabelUI text={label} />}
            helperText={<FormErrorUI message={errors[name]} />}
            disabled={viewField}
            InputLabelProps={{ shrink: true }}
          />
        </div>
      ))}
    </div>
  );
};

export default DigitalSigningSettingFields;
